// extracted by mini-css-extract-plugin
export default {"button":"PartnersStoreMenu_button__BritO","activeButton":"PartnersStoreMenu_activeButton__GwOBX"};